import { makeStyles, Theme, createStyles } from "@material-ui/core";

const drawerWidth = 256;
const paddingLR = 8;

const useStyles = makeStyles((theme: Theme) => createStyles({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContent: {
    position: 'relative',
    height: '100%',
    padding: `12px ${paddingLR}px`,
  }
}));

export default useStyles;